<template>
  <v-container>
    <!-- <CompanyPausedPerson :selectedBookPaused="selectedPerson" v-if="selectedPerson.id >= 0"></CompanyPausedPerson> -->
    <div class="title-icon">
      <h1>{{ $t("labels.pause") }}</h1>
      <v-btn
        icon
        :href="links.ebook.pauses"
        target="_blank"
      >
        <v-icon>$sl-question</v-icon>
      </v-btn>
    </div>

    <p v-html="$t('company.paused-text')"></p>

    <v-text-field
      class="search-field mb-4 mt-5"
      prepend-icon="$sl-search"
      single-line
      hide-details
      :label="$t('application.search-label')"
      @input="init"
      v-model="search"
    ></v-text-field>
    <template v-if="hasDepartments($route.params.id) == true">
      <MessageBox type="info" class="mb-8" v-if="!isAdministrator">
        <p>
          {{ $t("company.paused-messagebox") }}
          {{ getCurrentUserDepartments($route.params.id, isAdministrator, true) }}
        </p>
      </MessageBox>
      <v-tabs
        v-model="tab"
        :fixed-tabs="$vuetify.breakpoint.xsOnly"
        :centered="$vuetify.breakpoint.xsOnly"
      >
        <v-tab key="1">{{ $t("labels.all") }}</v-tab>
        <v-tab key="2">{{ $t("company.sections") }}</v-tab>
      </v-tabs>

      <v-tabs-items v-model="tab">
        <v-tab-item key="1">
          <CompanyPausedPersonDetail :searched="searched"></CompanyPausedPersonDetail>
        </v-tab-item>
        <v-tab-item key="2">
          <CompanyPausedPersonDepartments
            :searched="searchedDep"
          ></CompanyPausedPersonDepartments>
        </v-tab-item>
      </v-tabs-items>
    </template>
    <CompanyPausedPersonDetail v-else :searched="searched"></CompanyPausedPersonDetail>
    <v-btn
      fixed
      fab
      bottom
      right
      class="elevation"
      color="primary"
      :disabled="isImitatingUser()"
      @click="
        $nextTick(() => {
          $router.push({ name: 'CompanyPausedPerson', params: { id: $route.params.id } });
        })
      "
    >
      <!-- @click="selectedPerson.id = 0"> -->
      <v-icon>$sl-add</v-icon>
    </v-btn>
  </v-container>
</template>

<script>
import API from "@/services/api.js";
import ActionButton from "@/components/Common/ActionButton";
import filter from "lodash/filter";
import find from "lodash/find";
import uniq from "lodash/uniq";
import { mapActions, mapGetters } from "vuex";
import MessageBox from "@/components/Common/MessageBox";
//import CompanyPausedPerson from '@/components/Company/CompanyPausedPerson'
import CompanyPausedPersonDetail from "@/components/Company/CompanyPausedPersonDetail";
import CompanyPausedPersonDepartments from "@/components/Company/CompanyPausedPersonDepartments";
import { CompanyRoles } from "@/components/mixins";

const SugarDate = require("sugar/date");

export default {
  name: "CompanyPausedPersons",
  mixins: [CompanyRoles],
  components: {
    ActionButton,
    CompanyPausedPersonDetail,
    MessageBox,
    CompanyPausedPersonDepartments,
  },

  data: () => ({
    links: require('../../lib/external-links.json'),
    search: "",
    tab: null,
    apprentices: [],
    selectedPerson: {
      id: -1,
    },
    sections: [], //Avdelningar
  }),

  created() {
    this.init();
    //console.log('curr::', this.currentUser)
  },

  computed: {
    ...mapGetters("currentuser", [
      "currentUser",
      "isInstructor", 
      "isAdministrator",
      "isImitatingUser"
    ]),
    /**
     * Used get all exemptions or search exemptions if search is required from user
     * @arg called with no is a string comming from search bar
     */
    searched() {
      let result = [];
      if (this.search === "") {
        result = this.apprentices;
      } else {
        let normalizedSearch = this.search.toLowerCase();

        result = this.apprentices.filter(
          (x) =>
            (x.book.person.firstName &&
              x.book.person.firstName.toLowerCase().includes(normalizedSearch)) ||
            (x.book.person.lastName &&
              x.book.person.lastName.toLowerCase().includes(normalizedSearch))
        );
      }
      return result;
    },
    searchedDep() {
      let result = [];
      if (this.search === "") {
        result = this.apprentices;
      } else {
        let normalizedSearch = this.search.toLowerCase();

        result = this.apprentices.filter(
          (x) =>
            (x.book.person.firstName &&
              x.book.person.firstName.toLowerCase().includes(normalizedSearch)) ||
            (x.book.person.lastName &&
              x.book.person.lastName.toLowerCase().includes(normalizedSearch))
        );
      }
      return result;
    },
  },

  methods: {
    /**
     * @vuese
     * Used to call method  getApprenticeById or  getEmployeeById based on route name
     * @arg called with no argument
     */
    init() {
      this.getPausedApprentices();
    },
    /**
     * @vuese
     * Used to get the list of paused employees
     * @arg The argument is an integer value representing company id
     */
    getPausedApprentices() {
      if (!(this.$route && this.$route.params && this.$route.params.id)) return;
      let result = [];

      API.listPauseBooks({ companyId: this.$route.params.id })
        .then((response) => {
          //console.log("listPauseBooks::", response.data);
          if (this.hasDepartments(this.$route.params.id)) {
            //let emp = this.currentUser.employments.find(x => x.companyId == this.$route.params.id)
            response.data.forEach((resp) => {
              resp.book.person.apprenticeships.forEach((appr) => {
                appr.workplaces.forEach((wp) => {
                  if (wp.workplaceaddress.companyId == this.$route.params.id) {
                    result.push(resp);
                  }
                });
              });
            });
            this.apprentices = uniq(
              result.filter(
                (x) => x.approvedBySecondaryId && x.approvedBySecondaryId > 0
              ),
              "id"
            );
          } else {
            this.apprentices = response.data.filter(
              (x) => x.approvedBySecondaryId && x.approvedBySecondaryId > 0
            );
          }
        })
        .catch((error) => {
          console.log("There was an error:", error);
        });
    },
    /**
     * @vuese
     * Used to edit the pause period
     * @arg The argument is
     */
    editClick(emp) {
      this.selectedPerson = emp;
    },
  },
};
</script>
<style scoped></style>
